export default __webpack_public_path__ + "static/media/completed_male.c752088c.png";